import { Spacing } from '../../theme';

export const CardSpacingKey: keyof Spacing = '6x';
